// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-FA1bV","arrow":"arrow-2hvEu"};